export const usePromiseQuery = (query, params) => {
  return variables => {
    return params.client.query({
      query,
      fetchPolicy: 'network-only',
      ...params,
      variables: variables || params.variables
    })
  }
}
